import { unitKerjaAxiosDelete } from "../../../../Utils/axiosFunctions";
import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import DeleteModal from "../../../../Layout/Components/DeleteModal";
import UnitKerjaBaruModal from "../components/UnitKerjaBaruModal";

const UnitKerjaColumns = (resetState) => [
  {
    name: <DataTableTitle text={"Id Unit Kerja"} />,
    selector: (row) => row.id_unit_kerja,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Kode Unit Kerja"} />,
    selector: (row) => row.kode_unit_kerja,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Nama Unit Kerja"} />,
    selector: (row) => row.nama_unit_kerja,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Nama Kepala"} />,
    selector: (row) => row.nama_kepala,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Nama Jabatan"} />,
    selector: (row) => row.nama_jabatan,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Email Milis"} />,
    selector: (row) =>
      row.email_milis !== null
        ? row.email_milis.split(",").join("\n")
        : row.email_milis,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Nama Unit Kerja Lokal"} />,
    selector: (row) => row.nama_unit_kerja_lokal,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Email PIC"} />,
    selector: (row) => row.email_pic,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Kode Baru"} />,
    selector: (row) => row.kode_baru,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Operasi"} />,
    cell: (row) => (
      <div>
        <UnitKerjaBaruModal create={false} uk={row} resetState={resetState} />
        &nbsp;&nbsp;
        <DeleteModal
          name={"unit"}
          axiosDelete={unitKerjaAxiosDelete}
          pk={row.pk}
          resetState={resetState}
          isIcon
        />
      </div>
    ),
  },
];

export default UnitKerjaColumns;
